import React from 'react'
import PropTypes from 'prop-types'

import { Button, BUTTON_SIZES } from 'shared/UI/Button'
import map from 'lodash/map'

import './style.css.scss'

const Buttons = (props) => {

  const renderButtons = () => {
    return map(props.buttons, (button) => {
      return (
        <Button
          key={Math.random()}
          className={`meeting-button ${button.className}`}
          size={BUTTON_SIZES.small}
          onClick={button.onClick}>
          <span className={button.icon} />
          {button.text}
        </Button>
      )
    })
  }

  return (
    <div className="live-event-buttons">
      {renderButtons()}
    </div>
    )
}

Buttons.propTypes = {
  buttons: PropTypes.array
}

export default Buttons
